import React from "react";
import DashboardLayout from "defaultComponents/LayoutContainers/DashboardLayout";
import DashboardNavbar from "defaultComponents/Navbars/DashboardNavbar";
import VuiBox from "components/VuiBox";
import Card from "@mui/material/Card";
import { Grid, Box } from "@mui/material";
import filter from "assets/icons/filter.svg";
import * as S from "./style";
import { IoArrowUp, IoArrowDown, IoAlertCircleOutline } from "react-icons/io5";
import instagram from "assets/icons/socials/instagramwhite.svg";
import tiktok from "assets/icons/socials/tiktokwhite.svg";
import twitter from "assets/icons/socials/twitterwhite.svg";
import youtube from "assets/icons/socials/youtubewhite.svg";
import spotify from "assets/icons/socials/spotifywhite.svg";
import LineChart from "defaultComponents/Charts/LineCharts/LineChart";
import { TokenContext } from "context/TokenContext";
import { useParams } from "react-router-dom";
import { RiAddFill } from "react-icons/ri";
import Modal from "components/Modal/Modal";

import moment from "moment";
import "moment/locale/pt-br";

import "assets/theme/custom-flatpickr.css";

import { getMetrics } from "utils/requests/other";
import Datepicker from "components/Datepicker/Datepicker";
import AddMetricsForm from "./AddMetricsForm";
import { abbreviateNumbers } from "utils/utils";

const Metrics = () => {
  moment.locale("pt-br");

  const params = useParams();

  const { decodedToken } = React.useContext(TokenContext);
  const role = decodedToken?.type;

  const [initialDates, setInitialDates] = React.useState([moment().subtract(1, 'month').format('DD-MM-YYYY HH:mm'), moment().format('DD-MM-YYYY HH:mm')]);
  const [socialData, setSocialData] = React.useState();
  const [open, setOpen] = React.useState(false);
  const [followersChartData, setFollowersChartData] = React.useState([]);
  const [impressionsChartData, setImpressionsChartData] = React.useState([]);
  const [reachChartData, setReachChartData] = React.useState([]);
  const [chartOptions, setChartOptions] = React.useState({
    chart: {
      toolbar: {
        show: false,
      },
    },
    tooltip: {
      theme: "dark",
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    xaxis: {
      type: "datetime",
      categories: [
        "Jan",
        "Fev",
        "Mar",
        "Abr",
        "Mai",
        "Jun",
        "Jul",
        "Ago",
        "Set",
        "Out",
        "Nov",
        "Dez",
      ],
      labels: {
        style: {
          colors: "#c8cfca",
          fontSize: "10px",
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: "#c8cfca",
          fontSize: "10px",
        },
      },
    },
    legend: {
      show: false,
    },
    grid: {
      strokeDashArray: 5,
      borderColor: "#56577A",
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "dark",
        type: "vertical",
        shadeIntensity: 0,
        gradientToColors: undefined, // optional, if not defined - uses the shades of same color in series
        inverseColors: true,
        opacityFrom: 0.8,
        opacityTo: 0,
        stops: [],
      },
      colors: ["#FC6009", "#F8DF00", "#33CCFF", "#FF0000", "#00D554"],
    },
    colors: ["#FC6009", "#F8DF00", "#33CCFF", "#FF0000", "#00D554"],
  });
  const [openConstruction, setOpenConstruction] = React.useState(false);

  const fetchData = async () => {
    const startDate = moment(initialDates[0], "DD-MM-YYYY HH:mm").valueOf();
    const endDate = moment(initialDates[1], "DD-MM-YYYY HH:mm").valueOf();
    const username = params?.influencer || decodedToken?.username;
    const data = await getMetrics(username , startDate, endDate );
    const followersChartData = [];
    const impressionsChartData = [];
    let categories = [];
    if (!data.message) {
      setSocialData({
        ...data?.aggregatedMetrics,
        ...data?.socialMediaTrends,
      });
      data?.metrics.forEach(column => {
        if (column.name.includes('followers')) {
          followersChartData.push({
            name: column.name.split('_')[0],
            data: column.data,
          })
        }
        if (column.name.includes('impressions')) {
          impressionsChartData.push({
            name: column.name.split('_')[0],
            data: column.data,
          })
        }
        if (column.name.includes('week')) {
          categories = column.data.map(item => moment(item).format('DD/MM/YYYY'));
        }
      })
      setFollowersChartData(followersChartData);
      setImpressionsChartData(impressionsChartData);
      // setReachChartData(data?.reach?.graph);
      setChartOptions((chartOptions) => ({
        ...chartOptions,
        xaxis: {
          ...chartOptions.xaxis,
          categories: categories,
        },
      }));
    }
  };

  const getMostRecentData = (socialMedia) => {
    const mostRecentData = {
      followers: 0,
      impressions: 0,
      reactions: 0,
    }

    const foundFollowers = followersChartData.find(item => item.name === socialMedia)?.data;
    const foundImpressions = impressionsChartData.find(item => item.name === socialMedia)?.data;
    // const foundReactions = monthlyReactionsGraph.find(item => item.name === socialMedia);
    if (!foundFollowers || !foundImpressions) return mostRecentData;
    mostRecentData.followers = [...foundFollowers].pop() ?? 0
    mostRecentData.impressions = [...foundImpressions].pop() ?? 0;
    // mostRecentData.reactions = [...foundReactions].pop() ?? 0;
    return mostRecentData;
  }

  React.useEffect(() => {
    if (initialDates.length > 0) fetchData();
  }, [initialDates]);

  const redirects = {
    ADMINISTRATOR: {
      instagram: `/influencers/${params?.influencer}/metricas/instagram`,
      tiktok: `/influencers/${params?.influencer}/metricas/tiktok`,
    },
    H_COMERCIAL: {
      instagram: `/influencers/${params?.influencer}/metricas/instagram`,
      tiktok: `/influencers/${params?.influencer}/metricas/tiktok`,
    },
    COMERCIAL: {
      instagram: `/influencers/${params?.influencer}/metricas/instagram`,
      tiktok: `/influencers/${params?.influencer}/metricas/tiktok`,
    },
    H_MARKETING: {
      instagram: `/influencers/${params?.influencer}/metricas/instagram`,
      tiktok: `/influencers/${params?.influencer}/metricas/tiktok`,
    },
    MARKETING: {
      instagram: `/influencers/${params?.influencer}/metricas/instagram`,
      tiktok: `/influencers/${params?.influencer}/metricas/tiktok`,
    },
    INFLUENCER: {
      instagram: "/metricas/instagram",
      tiktok: "/metricas/tiktok",
    },
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container spacing="18px">
        <Grid item sm={12} md={12} lg={12} xl={12}>
          <Grid container justifyContent="space-between">
            <Datepicker setDate={setInitialDates} />
            <S.UpdateButtonGrid>
              <S.EditButton>
                <img src={filter} />
              </S.EditButton>
            </S.UpdateButtonGrid>
          </Grid>
        </Grid>
        <Grid item xl={12}>
          <Card>
            <S.BoardGrid container justifyContent="space-between">
              <S.ProgressGrid item xl={3}>
                <Grid container justifyContent="space-between">
                  <p className="followers">Seguidores</p>
                  <Grid item display="flex">
                    <p>{socialData?.followers ?? 0}</p>
                    {socialData && socialData?.followersTrend == 'up' ? (
                      <IoArrowUp color="#65EFAD" size="22px" />
                    ) : (
                      <IoArrowDown color="#D7007B" size="22px" />
                    )}
                  </Grid>
                </Grid>
                <S.BarContainer container>
                  <div className="bar">
                    <div className="instagram" style={{ width: "40%" }} />
                    <div className="tiktok" style={{ width: "20%" }} />
                    <div className="twitter" style={{ width: "20%" }} />
                    <div className="youtube" style={{ width: `15%` }} />
                    <div className="spotify" style={{ width: "5%" }} />
                  </div>
                </S.BarContainer>
              </S.ProgressGrid>
              <S.SocialCardsGrid item container xl={7}>
                <S.PageLink to={redirects[role]?.instagram}>
                  <S.SocialGrid className="instagram" item xl={2}>
                    <S.SocialNameGrid container justifyContent="center" gap="2px">
                      <img width="16px" src={instagram} />
                      <p>Instagram</p>
                    </S.SocialNameGrid>
                    <Grid container justifyContent="center">
                      <p>
                        {socialData
                          ? abbreviateNumbers(getMostRecentData("Instagram")?.followers ?? 0, 2)
                          : ""}
                      </p>
                      {socialData && socialData?.Instagram?.followers == 'up' ? (
                        <IoArrowUp color="#65EFAD" size="22px" />
                      ) : (
                        <IoArrowDown color="#D7007B" size="22px" />
                      )}
                    </Grid>
                  </S.SocialGrid>
                </S.PageLink>
                <S.PageLink to={redirects[role]?.tiktok}>
                  <S.SocialGrid
                    className="tiktok"
                    item
                    xl={2}
                    onClick={() => setOpenConstruction(true)}
                  >
                    <S.SocialNameGrid container justifyContent="center" gap="2px">
                      <img width="16px" src={tiktok} />
                      <p>TikTok</p>
                    </S.SocialNameGrid>
                    <Grid container justifyContent="center">
                      <p>
                        {socialData
                          ? abbreviateNumbers(getMostRecentData("tiktok")?.followers ?? 0, 2)
                          : ""}
                      </p>
                      {socialData && socialData?.Tiktok?.followers == 'up' ? (
                        <IoArrowUp color="#65EFAD" size="22px" />
                      ) : (
                        <IoArrowDown color="#D7007B" size="22px" />
                      )}
                    </Grid>
                  </S.SocialGrid>
                </S.PageLink>
                <S.SocialGrid
                  className="twitter"
                  item
                  xl={2}
                  onClick={() => setOpenConstruction(true)}
                >
                  <S.SocialNameGrid container justifyContent="center" gap="2px">
                    <img width="16px" src={twitter} />
                    <p>Twitter</p>
                  </S.SocialNameGrid>
                  <Grid container justifyContent="center">
                    <p>
                      {socialData
                        ? abbreviateNumbers(getMostRecentData("twitter")?.followers ?? 0, 2)
                        : ""}
                    </p>
                    {socialData && socialData?.Twitter?.followers == 'up' ? (
                      <IoArrowUp color="#65EFAD" size="22px" />
                    ) : (
                      <IoArrowDown color="#D7007B" size="22px" />
                    )}
                  </Grid>
                </S.SocialGrid>
                <S.SocialGrid
                  className="youtube"
                  item
                  xl={2}
                  onClick={() => setOpenConstruction(true)}
                >
                  <S.SocialNameGrid container justifyContent="center" gap="2px">
                    <img width="16px" src={youtube} />
                    <p>Youtube</p>
                  </S.SocialNameGrid>
                  <Grid container justifyContent="center">
                    <p>
                      {socialData
                        ? abbreviateNumbers(getMostRecentData("youtube")?.followers ?? 0, 2)
                        : ""}
                    </p>
                    {socialData && socialData?.Youtube?.followers == 'up' ? (
                      <IoArrowUp color="#65EFAD" size="22px" />
                    ) : (
                      <IoArrowDown color="#D7007B" size="22px" />
                    )}
                  </Grid>
                </S.SocialGrid>
                <S.SocialGrid
                  className="spotify"
                  item
                  xl={2}
                  onClick={() => setOpenConstruction(true)}
                >
                  <S.SocialNameGrid container justifyContent="center" gap="2px">
                    <img width="16px" src={spotify} />
                    <p>Spotify</p>
                  </S.SocialNameGrid>
                  <Grid container justifyContent="center">
                    <p>
                      {socialData
                        ? abbreviateNumbers(getMostRecentData("spotify")?.followers ?? 0, 2)
                        : ""}
                    </p>
                    {socialData && socialData?.Spotify?.followers == 'up' ? (
                      <IoArrowUp color="#65EFAD" size="22px" />
                    ) : (
                      <IoArrowDown color="#D7007B" size="22px" />
                    )}
                  </Grid>
                </S.SocialGrid>
              </S.SocialCardsGrid>
            </S.BoardGrid>
            <Grid item xl={12}>
              <VuiBox sx={{ height: "250px" }}>
                <LineChart
                  key={followersChartData}
                  lineChartData={followersChartData}
                  lineChartOptions={chartOptions}
                />
              </VuiBox>
            </Grid>
          </Card>
        </Grid>
        <Grid item xl={12}>
          <Card>
            <Grid container justifyContent="space-between">
              <S.ProgressGrid item xl={3}>
                <Grid container justifyContent="space-between">
                  <p className="followers">Impressões</p>
                  <Grid item display="flex">
                    <p>{socialData?.impressions ?? 0}</p>
                    {socialData && socialData?.impressionsTrend == 'up' ? (
                      <IoArrowUp color="#65EFAD" size="22px" />
                    ) : (
                      <IoArrowDown color="#D7007B" size="22px" />
                    )}
                  </Grid>
                </Grid>
                <S.BarContainer container>
                  <div className="bar">
                    <div className="instagram" style={{ width: "40%" }} />
                    <div className="tiktok" style={{ width: "20%" }} />
                    <div className="twitter" style={{ width: "20%" }} />
                    <div className="youtube" style={{ width: `15%` }} />
                    <div className="spotify" style={{ width: "5%" }} />
                  </div>
                </S.BarContainer>
              </S.ProgressGrid>
              <S.SocialCardsGrid item container xl={7}>
                <S.PageLink to={redirects[role]?.instagram}>
                  <S.SocialGrid className="instagram" item xl={2}>
                    <S.SocialNameGrid container justifyContent="center" gap="2px">
                      <img width="16px" src={instagram} />
                      <p>Instagram</p>
                    </S.SocialNameGrid>
                    <Grid container justifyContent="center">
                      <p>
                        {socialData
                          ? abbreviateNumbers(getMostRecentData("instagram")?.impressions ?? 0, 2)
                          : ""}
                      </p>
                      {socialData && socialData?.Instagram?.impressions == 'up' ? (
                        <IoArrowUp color="#65EFAD" size="22px" />
                      ) : (
                        <IoArrowDown color="#D7007B" size="22px" />
                      )}
                    </Grid>
                  </S.SocialGrid>
                </S.PageLink>
                <S.PageLink to={redirects[role]?.tiktok}>
                  <S.SocialGrid
                    className="tiktok"
                    item
                    xl={2}
                    onClick={() => setOpenConstruction(true)}
                  >
                    <S.SocialNameGrid container justifyContent="center" gap="2px">
                      <img width="16px" src={tiktok} />
                      <p>TikTok</p>
                    </S.SocialNameGrid>
                    <Grid container justifyContent="center">
                      <p>
                        {socialData
                          ? abbreviateNumbers(getMostRecentData("tiktok")?.impressions ?? 0, 2)
                          : ""}
                      </p>
                      {socialData && socialData?.Tiktok?.impressions == 'up' ? (
                        <IoArrowUp color="#65EFAD" size="22px" />
                      ) : (
                        <IoArrowDown color="#D7007B" size="22px" />
                      )}
                    </Grid>
                  </S.SocialGrid>
                </S.PageLink>
                <S.SocialGrid
                  className="twitter"
                  item
                  xl={2}
                  onClick={() => setOpenConstruction(true)}
                >
                  <S.SocialNameGrid container justifyContent="center" gap="2px">
                    <img width="16px" src={twitter} />
                    <p>Twitter</p>
                  </S.SocialNameGrid>
                  <Grid container justifyContent="center">
                    <p>
                      {socialData
                        ? abbreviateNumbers(getMostRecentData("twitter")?.impressions ?? 0, 2)
                        : ""}
                    </p>
                    {socialData && socialData?.Twitter?.impressions == 'up' ? (
                      <IoArrowUp color="#65EFAD" size="22px" />
                    ) : (
                      <IoArrowDown color="#D7007B" size="22px" />
                    )}
                  </Grid>
                </S.SocialGrid>
                <S.SocialGrid
                  className="youtube"
                  item
                  xl={2}
                  onClick={() => setOpenConstruction(true)}
                >
                  <S.SocialNameGrid container justifyContent="center" gap="2px">
                    <img width="16px" src={youtube} />
                    <p>Youtube</p>
                  </S.SocialNameGrid>
                  <Grid container justifyContent="center">
                    <p>
                      {socialData
                        ? abbreviateNumbers(getMostRecentData("youtube")?.impressions ?? 0, 2)
                        : ""}
                    </p>
                    {socialData && socialData?.Youtube?.impressions == 'up' ? (
                      <IoArrowUp color="#65EFAD" size="22px" />
                    ) : (
                      <IoArrowDown color="#D7007B" size="22px" />
                    )}
                  </Grid>
                </S.SocialGrid>
                <S.SocialGrid
                  className="spotify"
                  item
                  xl={2}
                  onClick={() => setOpenConstruction(true)}
                >
                  <S.SocialNameGrid container justifyContent="center" gap="2px">
                    <img width="16px" src={spotify} />
                    <p>Spotify</p>
                  </S.SocialNameGrid>
                  <Grid container justifyContent="center">
                    <p>
                      {socialData
                        ? abbreviateNumbers(getMostRecentData("spotify")?.impressions ?? 0, 2)
                        : ""}
                    </p>
                    {socialData && socialData?.Spotify?.impressions == 'up' ? (
                      <IoArrowUp color="#65EFAD" size="22px" />
                    ) : (
                      <IoArrowDown color="#D7007B" size="22px" />
                    )}
                  </Grid>
                </S.SocialGrid>
              </S.SocialCardsGrid>
            </Grid>
            <Grid item xl={12}>
              <VuiBox sx={{ height: "250px" }}>
                <LineChart
                  key={impressionsChartData}
                  lineChartData={impressionsChartData}
                  lineChartOptions={chartOptions}
                />
              </VuiBox>
            </Grid>
          </Card>
        </Grid>
        <Grid item xl={12}>
          <Card>
            <Grid container justifyContent="space-between">
              <S.ProgressGrid item xl={3}>
                <Grid container justifyContent="space-between">
                  <p className="followers">Alcance</p>
                  <Grid item display="flex">
                    <p>{socialData?.reach?.total ?? 0}</p>
                    <IoArrowUp color="#65EFAD" size="22px" />
                  </Grid>
                </Grid>
                <S.BarContainer container>
                  <div className="bar">
                    <div className="instagram" style={{ width: "40%" }} />
                    <div className="tiktok" style={{ width: "20%" }} />
                    <div className="twitter" style={{ width: "20%" }} />
                    <div className="youtube" style={{ width: `15%` }} />
                    <div className="spotify" style={{ width: "5%" }} />
                  </div>
                </S.BarContainer>
              </S.ProgressGrid>
              <S.SocialCardsGrid item container xl={7}>
                <S.PageLink to={redirects[role]?.instagram}>
                  <S.SocialGrid className="instagram" item xl={2}>
                    <S.SocialNameGrid container justifyContent="center" gap="2px">
                      <img width="16px" src={instagram} />
                      <p>Instagram</p>
                    </S.SocialNameGrid>
                    <Grid container justifyContent="center">
                      <p>
                        {socialData
                          ? abbreviateNumbers(getMostRecentData("instagram")?.reach ?? 0, 2)
                          : ""}
                      </p>
                      {socialData && socialData?.Instagram?.reach == 'up' ? (
                        <IoArrowUp color="#65EFAD" size="22px" />
                      ) : (
                        <IoArrowDown color="#D7007B" size="22px" />
                      )}
                    </Grid>
                  </S.SocialGrid>
                </S.PageLink>
                <S.SocialGrid
                  className="tiktok"
                  item
                  xl={2}
                  onClick={() => setOpenConstruction(true)}
                >
                  <S.SocialNameGrid container justifyContent="center" gap="2px">
                    <img width="16px" src={tiktok} />
                    <p>TikTok</p>
                  </S.SocialNameGrid>
                  <Grid container justifyContent="center">
                    <p>
                      {socialData
                        ? abbreviateNumbers(getMostRecentData("tiktok")?.reach ?? 0, 2)
                        : ""}
                    </p>
                    {socialData && socialData?.Tiktok?.reach == 'up' ? (
                      <IoArrowUp color="#65EFAD" size="22px" />
                    ) : (
                      <IoArrowDown color="#D7007B" size="22px" />
                    )}
                  </Grid>
                </S.SocialGrid>
                <S.SocialGrid
                  className="twitter"
                  item
                  xl={2}
                  onClick={() => setOpenConstruction(true)}
                >
                  <S.SocialNameGrid container justifyContent="center" gap="2px">
                    <img width="16px" src={twitter} />
                    <p>Twitter</p>
                  </S.SocialNameGrid>
                  <Grid container justifyContent="center">
                    <p>
                      {socialData
                        ? abbreviateNumbers(getMostRecentData("twitter")?.reach ?? 0, 2)
                        : ""}
                    </p>
                    {socialData && socialData?.Twitter?.reach == 'up' ? (
                      <IoArrowUp color="#65EFAD" size="22px" />
                    ) : (
                      <IoArrowDown color="#D7007B" size="22px" />
                    )}
                  </Grid>
                </S.SocialGrid>
                <S.SocialGrid
                  className="youtube"
                  item
                  xl={2}
                  onClick={() => setOpenConstruction(true)}
                >
                  <S.SocialNameGrid container justifyContent="center" gap="2px">
                    <img width="16px" src={youtube} />
                    <p>Youtube</p>
                  </S.SocialNameGrid>
                  <Grid container justifyContent="center">
                    <p>
                      {socialData
                        ? abbreviateNumbers(getMostRecentData("youtube")?.reach ?? 0, 2)
                        : ""}
                    </p>
                    {socialData && socialData?.Youtube?.reach == 'up' ? (
                      <IoArrowUp color="#65EFAD" size="22px" />
                    ) : (
                      <IoArrowDown color="#D7007B" size="22px" />
                    )}
                  </Grid>
                </S.SocialGrid>
                <S.SocialGrid
                  className="spotify"
                  item
                  xl={2}
                  onClick={() => setOpenConstruction(true)}
                >
                  <S.SocialNameGrid container justifyContent="center" gap="2px">
                    <img width="16px" src={spotify} />
                    <p>Spotify</p>
                  </S.SocialNameGrid>
                  <Grid container justifyContent="center">
                    <p>
                      {socialData ? abbreviateNumbers(socialData[4]?.reach?.value ?? 0, 2) : ""}
                    </p>
                    {socialData && socialData[4]?.reach?.lastMonthChanges.up ? (
                      <IoArrowUp color="#65EFAD" size="22px" />
                    ) : (
                      <IoArrowDown color="#D7007B" size="22px" />
                    )}
                  </Grid>
                </S.SocialGrid>
              </S.SocialCardsGrid>
            </Grid>
            <Grid item xl={12}>
              <VuiBox sx={{ height: "250px" }}>
                <LineChart
                  key={reachChartData}
                  lineChartData={reachChartData}
                  lineChartOptions={chartOptions}
                />
              </VuiBox>
            </Grid>
          </Card>
        </Grid>
      </Grid>
      {role === "ADMINISTRATOR" && (
        <Box sx={{ "& > :not(style)": { m: 1 } }}>
          <S.ModalFab color="primary" onClick={() => setOpen(true)}>
            <RiAddFill size="30px" />
          </S.ModalFab>
        </Box>
      )}
      <Modal open={open} onClose={() => setOpen(false)}>
        <AddMetricsForm />
      </Modal>
      <Modal size="md" open={openConstruction} onClose={() => setOpenConstruction(false)}>
        <S.ConstructionModalGrid container flexDirection="column">
          <Grid container justifyContent="center" sx={{ fontSize: "32px" }}>
            <p>🚧</p>
            <p>Em manutenção</p>
            <p>🚧</p>
          </Grid>
          <S.WarningGrid container gap="5px">
            <IoAlertCircleOutline color="red" style={{ alignSelf: "center" }} />
            <p className="subtitle reminder">Lembrete:</p>
            <p className="subtitle">Estamos batalhando por essa novidade T.T</p>
          </S.WarningGrid>
        </S.ConstructionModalGrid>
      </Modal>
    </DashboardLayout>
  );
};

export default Metrics;
